import persistDataStore from './../redux/persistStore';
import store from '../redux/store';
import smartHttp from './smartHttp';
import {
  Endpoints,
  ReduxAction,
  isCCA,
  Cancelled,
  // FEATURE DISABLED (Release july-2026)
  // Suspended,
  // Active,
  // Verbiage,
  superUserGroup,
  csaUserGroup,
  ccaUserGroup,
  endUserGroup,
  viewerUserGroup,
  // FEATURE DISABLED (Release july-2026)
  // exhibitUserGroup,
} from './../constants';
import { Notify } from '../sharedcomponents/Alert/Notify';

export const getCSAContractsData = async () => {
  let csaActionData =
    persistDataStore.getState()?.userActionData?.csaUserActionInfo;

  // Check if user is super user
  const userGroups = store.getState()?.userInfo?.userInfo?.SPGGroups || [];
  const isSuperUser = userGroups.includes(superUserGroup);

  let queryParamsContract = {
    PageSize: 5000,
    Field:
      'contractNumber,contractType,HomogenizedCompany,hc_AccountID,isVirtualContract,mappedcontractnumber,virtualContractNo,bulkEntitlementEnable,contractStatus',
  };
  if (csaActionData?.type && csaActionData?.value) {
    switch (csaActionData?.type) {
      case 'hccompany': {
        queryParamsContract.Filter = `hC_AccountID:"${csaActionData?.value}"`;

        // Filter out Cancelled contracts for non-super users
        if (!isSuperUser) {
          queryParamsContract.Filter += ` and contractStatus!:"${Cancelled}"`;
        }

        const contractResponse = await smartHttp.get(
          Endpoints.contractApi,
          queryParamsContract,
        );
        let tempState = contractResponse.data?.results?.map((el, i) => {
          return {
            label: el.contractNumber,
            id: el.contractNumber,
            homogenizedCompany: el.homogenizedCompany,
            checked: true,
            ...el,
          };
        });
        return tempState;
      }
      case 'account': {
        queryParamsContract.Filter = `accountId:"${csaActionData?.value}"`;

        // Filter out Cancelled contracts for non-super users
        if (!isSuperUser) {
          queryParamsContract.Filter += ` and contractStatus!:"${Cancelled}"`;
        }

        const contractResponse = await smartHttp.get(
          Endpoints.contractApi,
          queryParamsContract,
        );
        let tempState = contractResponse.data?.results?.map((el, i) => {
          return {
            label: el.contractNumber,
            id: el.contractNumber,
            homogenizedCompany: el.homogenizedCompany,
            checked: true,
            ...el,
          };
        });
        return tempState;
      }

      case 'contract': {
        queryParamsContract.Filter = `contractNumber:"${csaActionData?.value}"`;

        // Filter out Cancelled contracts for non-super users
        if (!isSuperUser) {
          queryParamsContract.Filter += ` and contractStatus!:"${Cancelled}"`;
        }

        const contractResponse = await smartHttp.get(
          Endpoints.contractApi,
          queryParamsContract,
        );
        let hc_accountid = contractResponse.data?.results[0].hC_AccountID;
        let csaSelectedContract = [
          {
            label: csaActionData?.value,
            id: csaActionData?.value,
            checked: true,
            contractNumber: csaActionData?.value,
            hC_AccountID: hc_accountid,
            homogenizedCompany:
              contractResponse.data?.results[0].homogenizedCompany,
            isVirtualContract:
              contractResponse.data?.results[0].isVirtualContract,
            mappedContractNumber:
              contractResponse.data?.results[0].mappedContractNumber,
            bulkEntitlementEnable:
              contractResponse.data?.results[0].bulkEntitlementEnable,
            virtualContractNo:
              contractResponse.data?.results[0].virtualContractNo,
          },
        ];
        return csaSelectedContract;
      }
      case 'user': {
        let queryParams = {
          PageSize: 5000,
          Field: 'contractNumber,hc_AccountID',
          Filter: `email:"${csaActionData?.value}"`,
        };
        const usersContractResponse = await smartHttp.get(
          Endpoints.userApi,
          queryParams,
        );
        let tempState = usersContractResponse.data?.results?.map((el, i) => {
          return {
            label: el.contractNumber,
            id: el.contractNumber,
            checked: true,
            ...el,
          };
        });
        return tempState;
      }
    }
  }
  return [];
};

export const updateVirtualContractsData = (contracts) => {
  let isVirtualContract = false;
  if (isCCA) {
    isVirtualContract = contracts?.some(
      (contract) => contract.isVirtualContract == 1,
    );
  }
  return isVirtualContract
    ? contracts?.filter((contract) => contract.isVirtualContract == 1)
    : contracts;
};

export const updateVirtualContractsInFilter = (
  agParams,
  isVirtualContractExists,
  contracts,
) => {
  if (isVirtualContractExists && agParams?.filterModel['contractNumber']) {
    contracts.map((cn) => {
      if (cn.isVirtualContract === 1) {
        let newFilterContracts = cn?.mappedContractNumber
          ?.split(',')
          .map((x) => `"${x}"`)
          .join(',');
        if (
          newFilterContracts &&
          agParams.filterModel['contractNumber']?.filter.includes(
            cn.contractNumber,
          )
        ) {
          agParams.filterModel['contractNumber'].filter = agParams.filterModel[
            'contractNumber'
          ].filter.replace(`"${cn.contractNumber}"`, newFilterContracts);
        }
      }
    });
  }
  return agParams;
};
export const getSelectedContractNumbers = (contracts) => {
  const contractNumbers = [
    ...new Set(
      contracts
        .filter((x) => x.checked)
        .flatMap((t) =>
          t.isVirtualContract && t.mappedContractNumber
            ? t.mappedContractNumber
                .split(',')
                .map((s) => s.trim())
                .filter(Boolean)
            : t.id
              ? [t.id]
              : [],
        ),
    ),
  ];

  const contractNumberFilter = contractNumbers
    .map((num) => `"${num}"`)
    .join(',');

  return { contractNumbers, contractNumberFilter };
};

// Singleton promise to prevent multiple simultaneous API calls for dbConfig
let dbConfigPromise = null;

export const getDbConfigData = async (dispatch, token = '') => {
  try {
    // Get the dbConfig data from the DB and save it in store
    let dbConfigData = store.getState()?.dbConfig;
    if (dbConfigData && Object.keys(dbConfigData).length > 0) {
      return dbConfigData;
    }

    // If a request is already in progress, wait for it instead of making a new one
    if (dbConfigPromise) {
      return await dbConfigPromise;
    }

    // Create the promise for fetching config data
    dbConfigPromise = (async () => {
      try {
        let queryParams = {
          keyItem: `FEEDBACKCOLLECTION, JOBFUNCTIONCOLLECTION, DESIGNATIONCOLLECTION, SFS_EXPORT_LIMIT, SFS_LIMIT_CONFIGURATION, MAX_CONTRACT_LIMIT, MANAGE_USER_ID_DISTRIBUTORS, RESTRICTED_COUNTRIES, MANAGE_USER_ID_DISTRIBUTORS_REQUIRED, REPORT_CRITERIAS, RECOMMENDED_PLATFORMS, ENTITLEMENT_STATUS_DEFINITION, SFS_DELETE_ENTITLEMENT_THRESHOLD, USER_GUIDES_AND_TRAINING_URLS, Training_Email_Template, Feedback_Email_Template, TLC_Link, EXPLORE_OUR_SOLUTIONS`,
        };
        let tokenHeader = {};
        if (token) {
          tokenHeader = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
        }
        let dbConfigResponse = await smartHttp.get(
          Endpoints.configurationApi,
          queryParams,
          tokenHeader,
        );

        let newDbConfig = {
          feedbackCollection: [],
          jobFunctionCollection: [],
          designationCollection: [],
          ManageUserIdDistributors: [],
          restrictedCountries: '',
          reportCriterias: [],
          exportLimit: 25000,
          entitlementStatusDefinition: [],
          userGuidesAndTrainingUrls: [],
          emailTemplates: {},
          configuration: {},
          tlcLinks: [],
          exploreOurSolutions: { commodities: [], capabilities: [] },
        };

        dbConfigResponse?.data?.results?.map((item) => {
          switch (item.keyItem) {
            case 'FEEDBACKCOLLECTION':
              newDbConfig.feedbackCollection = JSON.parse(item.keyValue);
              break;
            case 'JOBFUNCTIONCOLLECTION':
              newDbConfig.jobFunctionCollection = JSON.parse(item.keyValue);
              break;
            case 'DESIGNATIONCOLLECTION':
              newDbConfig.designationCollection = JSON.parse(item.keyValue);
              break;
            case 'SFS_EXPORT_LIMIT':
              newDbConfig.exportLimit = JSON.parse(item.keyValue);
              break;
            case 'MANAGE_USER_ID_DISTRIBUTORS':
              newDbConfig.ManageUserIdDistributors = JSON.parse(item.keyValue);
              break;
            case 'RESTRICTED_COUNTRIES':
              newDbConfig.restrictedCountries = item.keyValue;
              break;
            case 'REPORT_CRITERIAS':
              newDbConfig.reportCriterias = JSON.parse(item.keyValue);
              break;
            case 'RECOMMENDED_PLATFORMS':
              newDbConfig.recommendedPlatforms = JSON.parse(item.keyValue);
              break;
            case 'ENTITLEMENT_STATUS_DEFINITION':
              newDbConfig.entitlementStatusDefinition = JSON.parse(
                item.keyValue,
              );
              break;
            case 'SFS_DELETE_ENTITLEMENT_THRESHOLD':
              newDbConfig.deleteEntitlementThreshold = JSON.parse(
                item.keyValue,
              );
              break;
            case 'USER_GUIDES_AND_TRAINING_URLS':
              newDbConfig.userGuidesAndTrainingUrls = JSON.parse(item.keyValue);
              break;
            case 'Training_Email_Template':
              newDbConfig.emailTemplates.training = JSON.parse(item.keyValue);
              break;
            case 'Feedback_Email_Template':
              newDbConfig.emailTemplates.feedback = JSON.parse(item.keyValue);
              break;
            case 'SFS_LIMIT_CONFIGURATION':
              newDbConfig.configuration = JSON.parse(item.keyValue);
              break;
            case 'MAX_CONTRACT_LIMIT':
              newDbConfig.maxContractLimit = JSON.parse(item.keyValue);
              break;
            case 'TLC_Link':
              newDbConfig.tlcLinks = JSON.parse(item.keyValue);
              break;
            case 'EXPLORE_OUR_SOLUTIONS':
              newDbConfig.exploreOurSolutions = JSON.parse(item.keyValue);
              break;

            default:
              break;
          }
        });

        dispatch({
          type: ReduxAction.dbConfig,
          payload: newDbConfig,
        });

        return newDbConfig;
      } finally {
        // Reset the promise so future calls can make new requests if needed
        dbConfigPromise = null;
      }
    })();

    return await dbConfigPromise;
  } catch (err) {}
};

export const fetchUserPreferences = async (email, dispatch, token) => {
  const queryParams = {
    pageSize: 5000,
    Filter: `email:"${email.toLowerCase()}"`,
  };

  try {
    const resp = await smartHttp.get(Endpoints.userPreferenceApi, queryParams, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const response = resp.data.results;
    return response;
  } catch (error) {
    console.error('Error fetching user preferences:', error);
  }
};

// Fetch user contracts from user API to get contract type for primary user
export const fetchUserContracts = async (email, dispatch, token) => {
  try {
    const queryParams = {
      pageSize: 5000,
      Filter: `email:"${email.toLowerCase()}"`,
    };
    // Make an API request to fetch user contracts
    const resp = await smartHttp.get(Endpoints.userApi, queryParams, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const response = resp.data.results;
    // Dispatch an action to store the fetched user contracts in the Redux store
    dispatch({
      type: ReduxAction.userContractsSet,
      payload: response,
    });
    return response;
  } catch (error) {
    console.error('Error fetching user contracts:', error);
  }
};

// FEATURE DISABLED (Release july-2026) - Contract Suspension feature
// export const checkContractsSuspended = (contracts) => {
//   if (!contracts || !Array.isArray(contracts)) {
//     return { allSuspended: false, anySuspended: false, suspendedContracts: [] };
//   }
//   const checkedContracts = contracts.filter((c) => c.checked);
//   const suspendedContracts = checkedContracts.filter(
//     (c) => c.contractStatus === Suspended,
//   );
//   return {
//     allSuspended:
//       checkedContracts.length > 0 &&
//       suspendedContracts.length === checkedContracts.length,
//     anySuspended: suspendedContracts.length > 0,
//     suspendedContracts: suspendedContracts,
//     activeContracts: checkedContracts.filter(
//       (c) => c.contractStatus === Active,
//     ),
//   };
// };
export const checkContractsSuspended = () => ({ allSuspended: false, anySuspended: false, suspendedContracts: [], activeContracts: [] });

// FEATURE DISABLED (Release july-2026) - Contract Suspension feature
// export const isContractSuspended = (contract) => {
//   return contract?.contractStatus === Suspended;
// };
export const isContractSuspended = () => false;

// FEATURE DISABLED (Release july-2026) - Contract Suspension feature
// export const showSuspendedContractAlert = (contracts) => { ... };
export const showSuspendedContractAlert = () => {};

// FEATURE DISABLED (Release july-2026) - Dual-Persona / Exhibit Login Flow
// export const userGroupPriority = { ... };
// export const getHighestPriorityGroup = (userGroups) => { ... };
// export const shouldFilterSuspendedContracts = (userGroups) => { ... };
// export const classifyUserScenario = (rawGroups = []) => { ... };
export const userGroupPriority = {};
export const getHighestPriorityGroup = () => null;
export const shouldFilterSuspendedContracts = () => false;
export const classifyUserScenario = () => 'SINGLE_PERSONA';

// Returns the contractType for the given contractNumber by looking it up in the contracts array.
// Used when a user has multiple contracts sharing the same location so entitlements are
// routed to the correct contract based on package/contract type.
export const getContractTypeByContractNumber = (
  contracts = [],
  contractNumber = '',
) => {
  const normalizedContractNumber = String(contractNumber || '').trim();
  if (!normalizedContractNumber) return '';
  const matchedContract = (contracts || []).find((contract) => {
    const number = String(
      contract?.contractNumber || contract?.id || '',
    ).trim();
    return number === normalizedContractNumber;
  });
  return matchedContract?.contractType || '';
};
